module.exports = __webpack_public_path__ + "static/image 4-dc44c057512f82d6485073270b549465.png";